import React from "react";
import styled from "styled-components";
import textlogo from "../img/logo-text.png";
import PhoneFooter from "./PhoneFooter";
import { useStateContext } from "../global-context/useGlobalContext";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const Footer = () => {
  const { language } = useStateContext();
  const { pathname } = useLocation();
  const isPhone = useMediaQuery({ maxWidth: 676 });

  return (
    <FooterWrapper>
      {isPhone ? (
        <PhoneFooter></PhoneFooter>
      ) : (
        <div className="cpu-footer">
          <h4>
            <ul>
              <li>
                <Link
                  to="/"
                  className={pathname === "/" ? "onLink hover" : "hover"}
                >
                  {language ? "Accueil" : "Home"}
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className={
                    pathname === "/projects" ? "onLink hover" : "hover"
                  }
                >
                  {language ? "Projets" : "Projects"}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={
                    pathname === "/services" ? "onLink hover" : "hover"
                  }
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={pathname === "/contact" ? "onLink hover" : "hover"}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </h4>
          <h4 className="logo">
            <a href="https://www.jcesardesign.com">
              <img
                src={textlogo}
                alt=""
              />{" "}
              <span> ® - 2023</span>
            </a>
            <Link>{language ? "Mentions Légales" : "Legal Notice"}</Link>
          </h4>
          <h4>
            <span>Web Design :</span>
            <a
              href="mailto: robert@jcesardesign.com"
              className="hover"
            >
              robert@jcesardesign.com
            </a>
            <span>{language ? "Graphisme :" : "Graphic Design :"}</span>
            <a
              href="mailto: marine@jcesardesign.com"
              className="hover"
            >
              marine@jcesardesign.com
            </a>
            <a href="tel:+33781028463">+33 7 81 02 84 63</a>
          </h4>
        </div>
      )}
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.footer`
  height: fit-content;
  width: 100vw;
  z-index: 10;
  opacity: 0.9;
  background: #0c1d36;
  color: white;
  box-shadow: 0px 1px 10px black;
  .cpu-footer {
    padding: 0 10vw;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
    .logo {
      align-items: center;
    }
    h4 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: fit-content;
      height: 25vh;
      padding: 3vh 0;

      ul {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 25vh;
      }
      li {
        list-style: none;
      }

      @media (max-width: 850px) {
        padding: 0.5rem;
      }
    }
    img {
      height: 1.5vh;
    }
    .onLink {
      border-bottom: 1px solid #f9cc0b;
    }
    .hover:hover {
      color: #f9cc0b;
    }
  }
`;
